import { render, staticRenderFns } from "./MaterialSelect.vue?vue&type=template&id=151fdcdc&scoped=true&"
import script from "./MaterialSelect.vue?vue&type=script&lang=js&"
export * from "./MaterialSelect.vue?vue&type=script&lang=js&"
import style0 from "./MaterialSelect.vue?vue&type=style&index=0&id=151fdcdc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151fdcdc",
  null
  
)

export default component.exports